import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NbToastrService, NbGlobalPhysicalPosition} from '@nebular/theme';
import {TemplateService} from '../template.service';
import {TypeTemplateService} from '../../type-template/type-template.service';
import {debugOutputAstAsTypeScript} from '@angular/compiler';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'ngx-show-template',
  templateUrl: 'show-template.component.html',
  styleUrls: ['show-template.component.scss'],
})
export class ShowTemplateComponent implements OnInit {

  public template: any = {};
  public typesTemplate: any[] = [];
  public parentId = '';
  idTypeSelected = 0;

  registerForm: FormGroup;
  submitted = false;

  public selectControl = new FormControl();

  constructor(private templateService: TemplateService, private typeTemplateService: TypeTemplateService, private route: ActivatedRoute,
              private toastrService: NbToastrService, private router: Router, private formBuilder: FormBuilder) {
    this.parentId = this.route.snapshot.params.parentId;

  }

  ngOnInit() {

    this.getAllTypeTemplate();
    this.getCompany(this.parentId);

    this.registerForm = this.formBuilder.group({
      description: ['', Validators.required],
      idTypeSelected: ['', Validators.required],
    });

  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }

    this.save();
  }

  getAllTypeTemplate() {
    this.typeTemplateService.query().toPromise().then(result => {
      this.typesTemplate = result.body;
      for (let index = 0; index < this.typesTemplate.length; index++) {
        const element = this.typesTemplate[index];
        element.codeIndex = index + 1;
      }
    })
  }

  getCompany(parentId) {
    if (parentId === 'create') {
      this.template = {};
    } else {
      this.templateService.find(this.parentId).toPromise().then(response => {
        this.template = response.body;

        if (this.template.typeTemplate) {
          var id = this.template.typeTemplate.id;
          for (let index = 0; index < this.typesTemplate.length; index++) {
            const element = this.typesTemplate[index];
            if (element.id === id) {
              this.idTypeSelected = element.codeIndex;
            }
          }
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['pages/admin/template']);
  }

  setTypeTemplate() {
    for (let index = 0; index < this.typesTemplate.length; index++) {
      const element = this.typesTemplate[index];
      if (element.codeIndex === this.idTypeSelected) {
        this.template.typeTemplate = element;
      }
    }
  }

  save() {
    this.setTypeTemplate();
    if (this.template.id) {
      this.templateService.update(this.template).toPromise().then(response => {
        this.toastrService.show('Template', 'Salvo com sucesso',
          {position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success'});
        this.router.navigate(['pages/admin/template']);
      });
    } else {
      this.templateService.create(this.template).toPromise().then(response => {
        this.toastrService.show('Template', 'Salvo com sucesso',
          {position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success'});
        this.router.navigate(['pages/admin/template']);
      });
    }
  }

}
